<div
  class="search-list-root"
  [class.search-list-root--menu]="menuBar"
  (clickOutside)="closeSearch()">
  <ng-container *ngIf="showDropDown; else showName">
    <button
      mat-icon-button
      type="button"
      class="search-button"
      aria-label="Buscar socio"
      [attr.aria-expanded]="isSearchVisible"
      (mousedown)="$event.preventDefault()"
      (click)="openSearch($event)">
      <mat-icon>search</mat-icon>
    </button>
    <div class="search-popup" [class.visible]="isSearchVisible">
      <dx-list
        #searchList
        class="dx-list"
        [dataSource]="dataList"
        [searchEnabled]="true"
        [searchExpr]="['name']"
        itemTemplate="itemTemplate"
        selectionMode="single"
        (onItemClick)="onItemSelect($event)"
        [pageLoadMode]="'scrollBottom'">
        <div *dxTemplate="let item of 'itemTemplate'">
          <div class="search-item">
            <div class="search-item-header">
              <span class="rfc">{{ item.name.split(' | ')[0] }}</span>
              <span class="clave">{{ item.name.split(' | ')[2] }}</span>
              <span class="patente">{{ item.name.split(' | ')[3] }}</span>
            </div>
            <div class="search-item-name">{{ item.name.split(' | ')[1] }}</div>
          </div>
        </div>
      </dx-list>
    </div>
  </ng-container>
  <ng-template #showName>
    <dx-text-box
      class="dx-text-box"
      [value]="selectedItem"
      [readOnly]="true">
    </dx-text-box>
  </ng-template>
</div>